import * as Yup from "yup";

export const validationSchema = Yup.object({
    fromEmail: Yup
        .string()
        .required("Required"),
    // fromName: Yup
    //     .string()
    //     .required("Required"),
    // replyName: Yup
    //     .string()
    //     .required("Required"),
    // replyEmail: Yup
    //     .string()
    //     .required("Required"),
    hostUrl: Yup
        .string()
        .required("Required"),
    hostPort: Yup
        .string()
        .required("Required"),

})

export const initialValues = {
    fromEmail: "",
    fromName: "",
    replyName: "",
    replyEmail: "",
    hostUrl: "",
    hostPort: "",
}